import { defineComponent as _defineComponent } from 'vue'
import { useSurfaceCanvasConnection } from '@@/vuecomposables/surface_canvas_connection'
import device from 'bits/device'
import { storeToRefs } from 'pinia'
import { useSurfaceStore } from 'pinia/surface'
import type { Id } from 'types'
import { onMounted, ref, type Ref } from 'vue'
import SurfaceHeader from 'vuecomponents/SurfaceHeader.vue'
import SurfacePosts from 'vuecomponents/surface_posts.vue'
import { useDoubleClickToPost } from 'vuecomposables/surface_double_click_to_post'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceContainerCanvas',
  props: {
    reactionIdsByPostId: { default: () => ({}) },
    commentIdsByPostId: { default: () => ({}) }
  },
  emits: ["scroll"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'scroll', e: UIEvent): void
}), expose: any, slots: any, attrs: any }) {





const { xHeader, backgroundLuminance, isReadOnly } = storeToRefs(useSurfaceStore())
const wallContainer = ref<HTMLDivElement | null>(null)
const isPageScrollHandlerTicking = ref(false)
const headerTop = ref(0)
const headerLeft = ref(0)

// Keep the header at the same position when the page is scrolled
const handlePageScroll = (e: UIEvent): void => {
  emit('scroll', e)
  if (wallContainer.value != null && !isPageScrollHandlerTicking.value) {
    requestAnimationFrame(() => {
      const wallContainerEl = wallContainer.value as HTMLDivElement
      headerTop.value = -wallContainerEl.scrollTop
      headerLeft.value = wallContainerEl.scrollLeft
      isPageScrollHandlerTicking.value = false
    })
    isPageScrollHandlerTicking.value = true
  }
}

if (!device.mobile) useDoubleClickToPost()

onMounted(() => {
  useSurfaceCanvasConnection(wallContainer as Ref<HTMLElement>)
})

return { __sfc: true,emit, xHeader, backgroundLuminance, isReadOnly, wallContainer, isPageScrollHandlerTicking, headerTop, headerLeft, handlePageScroll, SurfaceHeader, SurfacePosts }
}

})